<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">经销商销售发票上传</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button v-if="conditions.status === '新建'" name="提交" icon="form-advance" @click="advanceData" />
        <!-- <template v-if="mode === 'edit'">
        </template> -->
        <template v-if="conditions.status !== '新建' && conditions.status !== '已保存'">
          <form-button name="返回" icon="form-advance" @click="$router.go(-1)" />
          <form-button name="下载使用说明书" @click="downLoadGuide" />
        </template>
      </div>
      <el-form ref="form" inline size="mini" :show-message="false" :disabled="conditions.status !== '新建'" label-width="100px" :model="conditions" :rules="rules">
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="单据号">
              <el-input
                v-model="conditions.invupl_id"
                placeholder="自动生成"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="invoice" label="发票号码">
              <el-input
                v-model="conditions.invoice"
                placeholder="请输入"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="inv_date" label="开票日期">
              <el-date-picker
                v-model="conditions.inv_date"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票类型">
              <el-select
                v-model="conditions.inv_type"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['A0032']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="订单客户">
              <wly-input
                v-model="conditions.customer"
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="openDialog($event, '客户选择')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.customername"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售方">
              <el-select
                v-model="conditions.sellername"
                placeholder="请选择"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据状态">
              <el-select
                v-model="conditions.status"
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0055']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="上传日期">
              <el-date-picker
                v-model="conditions.upl_date"
                type="date"
                value-format="yyyyMMdd"
                format="yyyy-MM-dd"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="基础信息"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button name="export" tip="导出" @click="exportExcel"></table-button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #product_id="{ row }">
            <wly-input
              v-model="row.product_id"
              size="mini"
              input-type="product"
              :query-params="{ customerCode: conditions.customer }"
              @enter="handleEnter(...arguments,row)"
              @handleSuffixClick="openDialog($event, '产品选择', row)"
            />
            <!-- <el-input
              v-model="row.product_id"
              size="mini"
              @focus="openDialog($event, '产品选择', row)"
            /> -->
          </template>
          <template #quantity="{ row }">
            <el-input v-model.number="row.quantity" @keyup.enter.native="enterInput(row)" />
          </template>
          <template #price="{ row }">
            <el-input v-model="row.price" @keyup.enter.native="enterInput(row)" />
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" :tip="gridOptionsFile.data.length ? '重新上传' : '上传'" />
          </el-upload>
          <table-button v-if="gridOptionsFile.data.length" name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{row}">
            <span class="blue" @click="downLoadFile(row)">{{
              row.filename
            }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
      destroy-on-close
    >
      <template v-if="dialogTitle === '产品选择'">
        <product-select ref="dialogSelect" :query-params="{ customerCode: conditions.customer, mode: 'DS' }" />
      </template>
      <template v-if="dialogTitle === '客户选择'">
        <client-select ref="dialogSelect" />
      </template>
      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
import { downLoadFile } from '@/api/sap/common-sap'
import { frontExport } from '@/utils/frontExport'
import { apiUploadInvoiceDetail, apiUpdateItem, apiUpdateSubmit } from '@/api/sap/dealer'
export default {
  name: 'InvoiceUpload',
  components: { ProductSelect, ClientSelect },
  data() {
    const rules = {
      inv_date: [{ required: true, message: '请选择开票日期', trigger: 'change' }],
      invoice: [{ required: true, message: '请填写发票号码', trigger: 'blur' }],
      customer: [{ required: true, message: '请选择订单客户名称', trigger: 'change' }]
    }
    return {
      rules,
      mode: 'add',
      showDialog: false,
      dialogTitle: '客户选择',
      conditions: {
        invupl_id: '',
        sellername: '',
        status: '新建',
        upl_date: '',
        invoice: '',
        inv_date: '',
        inv_type: '',
        customername: '',
        customer: '',
        seller: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          {
            field: 'product_id',
            title: '产品编号',
            slots: { default: 'product_id' }
          },
          {
            field: 'product_text',
            title: '产品名称'
          },
          {
            field: 'quantity',
            title: '数量（瓶）',
            slots: {
              default: 'quantity'
            }
          },
          {
            field: 'price',
            title: '含税单价（元/瓶）',
            slots: {
              default: 'price'
            }
          },
          {
            field: 'amount',
            title: '含税总价'
          }
        ],
        data: []
      },
      loading: false,
      xid: '',
      gridOptionsFile: {
        columns: [
          { field: 'filename', title: '附件名称', slots: { default: 'filename' }},
          { field: 'filetype', title: '附件类型' },
          { field: 'created_time', title: '上传时间' }
        ],
        data: []
      },
      currentRow: {},
      errorList: []
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'role'])
  },
  created() {
    this.getSelectDictDataOrigin('A0055')
    this.getSelectDictDataOrigin('A0032')
    this.conditions.upl_date = this.parseTime(new Date())

    this.conditions.customername = this.role.login_user
    this.conditions.customer = this.role.USER_BP

    this.conditions.sellername = this.role.login_user
    this.conditions.seller = this.role.USER_BP
    const { id } = this.$route.query

    if (id) {
      this.mode = 'edit'
      this.getDetail(id)
    }
  },
  methods: {
    exportExcel(type) {
      frontExport(this.gridOptions.columns, this.gridOptions.data, '经销商销售发票')
    },
    // 下载说明书
    async downLoadGuide() {
      const { data } = await downLoadFile({
        id: 'ZCRM_INVOICE_GUIDE'
      })
      sapDownloadFile(data.file_data, data.file_name)
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (!data) return
      if (this.dialogTitle === '客户选择') {
        this.conditions.customer = data.partner
        this.conditions.customername = data.customerName
      } else {
        this.currentRow.product_id = data.productCode
        this.currentRow.product_text = data.productShortName
      }
      this.showDialog = false
    },
    async enterInput(row) {
      if (!row.product_id) {
        return
      }
      this.currentRow = row
      const params = {
        info: this.conditions,
        item: row
      }
      this.errorList = []
      const res = await apiUpdateItem(params)
      if (res.msgtype === 'E') {
        this.errorList.push(res.message)
      }
      Object.assign(this.currentRow, res.data.item)
    },
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.filedata, row.filename)
    },
    // 查询详情
    async getDetail(id) {
      const { data } = await apiUploadInvoiceDetail({ invupl_id: id })
      Object.assign(this.conditions, data.info)
      this.gridOptions.data = data.item
      if (data.info.filename) {
        this.gridOptionsFile.data.push({
          filename: data.info.filename,
          filedata: data.info.filedata,
          created_time: data.info.datum
        })
      }
    },
    // 提交保存数据
    advanceData() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          const params = {
            user_bp: this.role.USER_BP,
            info: this.conditions,
            item: this.gridOptions.data.map(item => {
              const obj = { ...item }
              delete obj._X_ID
              return obj
            })
          }
          Object.assign(params.info, this.gridOptionsFile.data[0])
          this.errorList = []
          const res = await apiUpdateSubmit(params)
          if (res.msgtype === 'E') {
            this.errorList.push(res.message)
            return
          }
          this.$message.success(res.message)
          Object.assign(this.conditions, res.data.info)
          this.gridOptions.data = res.data.item
        } else {
          return false
        }
      })
    },
    delUpload() {
      this.gridOptionsFile.data = []
    },
    // 上传文件
    uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }
        strArr = strArr.join('')
        const fileData = {
          filename: file.name,
          filetype: file.raw.type,
          filedata: strArr,
          created_time: _this.parseTime(new Date())
        }
        _this.gridOptionsFile.data.splice(0, 1)
        _this.gridOptionsFile.data.push(fileData)
      }
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}-{m}-{d}')
    },
    // 打开弹窗
    openDialog(e, title, row = undefined) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
      row && (this.currentRow = row)
    },
    // 新增明细
    insertData() {
      const data = {
        product_id: '',
        product_text: '',
        amount: '',
        price: '',
        quantity: ''
      }
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      this.$refs.xTable.removeCheckboxRow()

      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      this.currentRow = row

      switch (type) {
        case 'customer':
          this.conditions.customer = data.partner
          this.conditions.customername = data.customerName
          break
        case 'product':
          this.currentRow.product_id = data.productCode
          this.currentRow.product_text = data.productShortName
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/dealer-manage/invoiceUpload.vue